import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function DarkModeIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18.25 15.0314C17.7575 15.1436 17.2459 15.2027 16.7209 15.2027C12.8082 15.2027 9.63607 11.9185 9.63607 7.86709C9.63607 6.75253 9.87614 5.69603 10.3057 4.75C7.12795 5.47387 4.75 8.40659 4.75 11.9143C4.75 15.9657 7.9221 19.25 11.8348 19.25C14.6711 19.25 17.1182 17.5242 18.25 15.0314Z"
        stroke="#B2B2BD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ stroke: "#B2B2BD", strokeOpacity: 1 }}
      />
    </svg>
  );
};
